const mutations = {
  SET_GENDERS (state, data) {
    state.genders = data
  },
  SET_TARGET_DEVICES (state, data) {
    state.targetDevices = data
  },
  SET_AGE_GROUPS (state, data) {
    state.ageGroups = data
  },
  SET_REJECT_REVIEW_REASONS (state, reasons) {
    state.rejectReviewReasons = reasons
  },
  SET_HOLD_REVIEW_REASONS (state, reasons) {
    state.holdReviewReasons = reasons
  },
  SET_CAMPAIGN_CATEGORIES (state, campaignCategories) {
    state.campaignCategories = campaignCategories
  },
  SET_ADVERTISING_CHANNELS (state, advertisingChannels) {
    state.advertisingChannels = advertisingChannels
  },
  SET_OBJECTIVES (state, objectives) {
    state.objectives = objectives
  },
  SET_DISPLAY_TYPES (state, types) {
    state.types = types
  },
  SET_DELETED_CAMPAIGN (state, campaign) {
    state.deletedCampaign = campaign
  },
  SET_LOGGED_IN_ACCOUNT_CAMPAIGNS (state, campaigns) {
    state.loggedInAccountCampaigns = campaigns
  },
  SET_TARGETING_LOOKUPS (state, lookups) {
    state.targeting_lookups = lookups
  }
}

export default mutations
